import React from 'react'

const CompleteProjects = ({ height, width }) =>
  <svg version="1.1" id="completedprojects" xmlns="http://www.w3.org/2000/svg" width={ width } height={ height } x="0px" y="0px" aria-labelledby="completedprojectsTitle" viewBox="0 0 264 264">
    <title id="completedprojectsTitle">Completed Projects Icon</title>
    <g>
      <path className="blue-icon" d="M247,33H17.9C8.2,33,0,40.9,0,50.6v163.1c0,9.7,8.1,17.3,17.9,17.3H247c9.7,0,17-7.6,17-17.3V50.6
          C264,40.7,256.7,33,247,33z M60.2,43c3.6,0,6.4,2.9,6.4,6.4s-2.9,6.4-6.4,6.4s-6.4-2.9-6.4-6.4S56.7,43,60.2,43z M41.7,43
          c3.6,0,6.4,2.9,6.4,6.4s-2.9,6.4-6.4,6.4s-6.4-2.9-6.4-6.4S38.2,43,41.7,43z M23.2,43c3.6,0,6.4,2.9,6.4,6.4s-2.9,6.4-6.4,6.4
          s-6.4-2.9-6.4-6.4S19.7,43,23.2,43z M248,214.5c0,0.3,0.1,0.5-0.2,0.5h-0.5H16.8H16v-0.5V67v-0.5c0-0.3,0.6-0.5,0.8-0.5h231
          c0.3,0,0.2,0.2,0.2,0.5V214.5L248,214.5z M241.9,56h-70c-3.6,0-6.4-2.9-6.4-6.5s2.9-6.5,6.4-6.5h70c3.6,0,6.4,2.9,6.4,6.5
          C248.3,53.1,245.4,56,241.9,56z"/>
      <g>
          <path className="blue-icon" d="M39.9,106h70c3.6,0,6.4-2.9,6.4-6.5s-2.9-6.5-6.4-6.5h-70c-3.6,0-6.4,2.9-6.4,6.5
              C33.4,103.1,36.3,106,39.9,106z"/>
          <path className="blue-icon" d="M109.9,115h-70c-3.6,0-6.4,2.9-6.4,6.5s2.9,6.5,6.4,6.5h70c3.6,0,6.4-2.9,6.4-6.5S113.4,115,109.9,115z"/>
          <path className="blue-icon" d="M109.9,137h-70c-3.6,0-6.4,2.9-6.4,6.5s2.9,6.5,6.4,6.5h70c3.6,0,6.4-2.9,6.4-6.5S113.4,137,109.9,137z"/>
          <path className="blue-icon" d="M109.9,159h-70c-3.6,0-6.4,2.9-6.4,6.5s2.9,6.5,6.4,6.5h70c3.6,0,6.4-2.9,6.4-6.5S113.4,159,109.9,159z"/>
      </g>
      <path className="blue-icon" d="M218.8,91h-74c-6.9,0-12.8,5.6-12.8,12.5v0.5v73.5v0.5c0,6.6,5.7,12,12.3,12h0.5h73.5h0.5
          c6.9,0,12.2-5.6,12.2-12.5v-74C231,96.6,225.7,91,218.8,91z"/>
    </g>
  </svg>

export default CompleteProjects
